import { useInitialHomePage } from "@nf/common";

import { useRouter } from "./useRouter";

export const useGoBackOrHome = () => {
  const router = useRouter();
  const { getInitialHomePage } = useInitialHomePage();

  const goBackOrHome = () => {
    if (window.history.length > 2) {
      router.back();
    } else {
      router.push(getInitialHomePage());
    }
  };

  return goBackOrHome;
};
